import React, { isValidElement, ReactNode } from 'react'

import { BreadcrumbItem } from './elements/BreadcrumbItem'
import { BreadcrumbSeparator } from './elements/BreadcrumbSeparator'
import * as Styled from './styles'

export interface BreadcrumbsProps {
  children: ReactNode
  separator?: ReactNode
}

export const Breadcrumbs = ({ children, separator }: BreadcrumbsProps) => (
  <Styled.BreadcrumbsWrapper>
    {React.Children.map(children, (child, index) => {
      if (!isValidElement(child)) {
        return null
      }

      const shouldShowSeparator = index !== React.Children.count(children) - 1

      return (
        <>
          {child}
          {shouldShowSeparator && (separator || <BreadcrumbSeparator />)}
        </>
      )
    })}
  </Styled.BreadcrumbsWrapper>
)

Breadcrumbs.Item = BreadcrumbItem
